import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";

export const GET_FAQ_GEWINNSPIEL = gql`
  query FaqGewinnspiel {
    faqGewinnspiel {
      categoryName
      subcategories {
        position
        subCategoryName
        questions {
          question
          answer
          position
        }
      }
    }
  }
`;
